module.exports = __webpack_public_path__ + "static/media/Industriekessel_06.f5b63d13.jpg";